export const GET_NEXT_ID = 'GET_NEXT_ID'
export const GET_COUNTRIES_LIST = 'GET_COUNTRIES_LIST'
export const GET_LANGUAGES = 'GET_LANGUAGES'
export const GET_USERS = 'GET_USERS'
export const GET_DASHBOARD_ROLES = 'GET_DASHBOARD_ROLES'
export const GET_PUB_IDS = 'GET_PUB_IDS'
